import {ErrorMessage, useField, useFormikContext} from "formik";
import React from "react";
import QuestionCopy from "./QuestionCopy";
import QuestionWrapper from "./QuestionWrapper";
import GooglePlacesAutocomplete, {geocodeByPlaceId} from "react-google-places-autocomplete";

type TDateFieldProps = {
  name: string;
  label?: string;
  note?: string;
  error?: boolean;
};

export default function AddressInput({
  name,
  label,
  note,
  error,
}: TDateFieldProps) {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(name);

  const onChange = (name, f) => {
    // Fetch postcode from using place ID
    geocodeByPlaceId(f.value.place_id)
        .then((results) => {
          const postcode = results[0].address_components.find(component => component.types.includes("postal_code"))
          f.value.structured_formatting.postal_code = postcode ? postcode.long_name : '';
          setFieldValue(name, f);
        })
        .catch((error) => console.error(error));
  }

  return (
    <QuestionWrapper flex>
      <QuestionCopy name={name} label={label} note={note} />
      <GooglePlacesAutocomplete
        apiKey="AIzaSyCfkSgVLtF-olrBFchmEvog-AGPhb9mxvI"
        apiOptions={{
          region: "AU",
        }}
        selectProps={{
          value: field.value,
          onChange: (f) => onChange(name, f),
          placeholder: null,
          styles: {
            menu: (provided: any) => ({
              ...provided,
              maxWidth: "343px",
              color: "#222221",
              fontSize: "16px",
            }),
            control: (provided: any, state: any) => {
              return {
                maxWidth: "343px",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                height: "48px",
                borderRadius: "3px",
                backgroundColor: "white",
                color: "#222221CC",
                fontSize: "16px",
                border: state.isFocused
                  ? "2px solid #005FCC"
                  : "1px solid #BDB49F",
                appearance: "none",
                position: "relative",
                outline: error ? "1px solid" : undefined,
                outlineColor: error ? "#D82727" : "005FCC",
                paddingLeft: "0.5rem",
              };
            },
            indicatorsContainer: () => ({ display: "none" }),
          },
        }}
      />
      <ErrorMessage name={name}>
        {(msg) => (
          <p style={{ fontSize: "14px", color: "#D82727", marginBottom: 0 }}>
            {msg}
          </p>
        )}
      </ErrorMessage>
    </QuestionWrapper>
  );
}
